import React from 'react';

import RDSHeading from '../../components/RDSHeading';
import RDSText from '../../components/RDSText';
import RDSButton from '../../components/RDSButton';

import styles from './DefaultBudgetCTA.module.css';

type BudgetCTAProps = {
  header?: string;
  text?: string;
  buttonText?: string;
  buttonLink?: string;
};

const DefaultBudgetCTA = (props: BudgetCTAProps) => {
  const header = props.header || 'This is a headline';
  const text =
    props.text ||
    'Here is some copy that will help you decide to create a free account.';
  const buttonText = props.buttonText || 'Try Premium for Free';
  const buttonProps = props.buttonLink
    ? {
        href: props.buttonLink,
      }
    : {};

  return (
    <div className={styles.DefaultBudgetCTA}>
      <RDSHeading size="medium" level={'3'} className={styles.Heading}>
        {header}
      </RDSHeading>
      <RDSText size={'bodyMedium'} className={styles.Text}>
        {text}
      </RDSText>
      <RDSButton element={'a'} size="medium" {...buttonProps}>
        {buttonText}
      </RDSButton>
    </div>
  );
};
export default DefaultBudgetCTA;
